export const DOCUMENT_TYPE_VALUES = [
  'StrengthTestResult',
  'DeliveryNote',
] as const;

export type DocumentType = typeof DOCUMENT_TYPE_VALUES[number];
